import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import { useNavigate } from "react-router-dom";
import studentServices from "../../../services/student.services";
import { toast } from "react-toastify";
import LoadingBar from "../toaster/loader/loader";
// var SignaturePad = require('react-signature-pad');
let languages = require('language-list')()


const StudenInfoThird = (props) => {
    const navigate = useNavigate()
    const [loading, setload] = useState(false)
    const [Fieldval, SetFieldVal] = useState({})
    const [langList, setLangList] = useState([])
    const [selected, setSelected] = useState([]);


    const handleFieldValue = (e) => {
        const name = e.target.name
        const value = e.target.value
        SetFieldVal({
            ...Fieldval,
            [name]: value
        })
    }

    const getLangList = async (e) => {
        const allLanguages = await languages.getData()
        allLanguages && allLanguages.map(curr => {
            setLangList(prevState => ([...prevState,
            {
                label: curr.language,
                value: curr.code
            }]))
        })

    }

    useEffect(() => {
        getLangList()
    }, [])

    const updateMyBio = (e) => {
        setload(true)
        Fieldval.languages_spoken = selected
        studentServices.UpdateStudentData(Fieldval)
            .then(resp => {
                setload(false)
                navigate('/student-dashboard')
                toast.success("Signup Successfully")
            })
            .catch(err => console.log(err))
        e.preventDefault()
    }

    useEffect(() => {
        async function getStudentProfile() {
            await studentServices.getStudentProfile().then((resp) => {
                SetFieldVal(resp.data.data.studentinfo ? resp.data.data.studentinfo : {})
                setSelected(resp.data.data.studentinfo.languages_spoken?resp.data.data.studentinfo.languages_spoken:[])
            }).catch(err => console.log(err, "<--- Err"))
        }
        getStudentProfile()

    }, [])

    return (
        <div className="dbbsc_info">

            {loading &&
                <LoadingBar />
            }
            <Form className="signform_div" onSubmit={(e) => updateMyBio(e)}>
                <Form.Group
                    controlId="formFile"
                    className="mb-3"
                >
                    <Form.Label>
                        Additional languages spoken?
                    </Form.Label>
                    <MultiSelect
                        className="multi_slct"
                        options={langList}
                        value={selected}
                        onChange={setSelected}
                        labelledBy="Select"
                        required
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <label className="d-block mb-2">
                        Interested in employment
                        opportunities while in school?
                    </label>

                    <Form.Check
                        inline
                        label="Yes"
                        type="radio"
                        name="employment_opportunities"
                        value='true'
                        checked={Fieldval && (Fieldval.employment_opportunities === 'true' || Fieldval.employment_opportunities === true) && true}
                        required={!Fieldval.employment_opportunities && true}
                        onChange={(e) => { handleFieldValue(e) }}
                        id="a1"
                    />
                    <Form.Check
                        inline
                        label="No"
                        type="radio"
                        name="employment_opportunities"
                        value='false'
                        checked={Fieldval && (Fieldval.employment_opportunities === 'false' || Fieldval.employment_opportunities === false) && true}
                        onChange={(e) => { handleFieldValue(e) }}
                        id="a2"
                    />
                </Form.Group>
                {
                    (Fieldval.employment_opportunities === "true" || Fieldval.employment_opportunities === true )&&
                    <Form.Group
                        controlId="formFile"
                        className="mb-3"
                    >
                        <Form.Label>
                            Specialty interested in?
                        </Form.Label>
                        <Form.Control
                            value={Fieldval?.specialy_interested}
                            type="text"
                            name='specialy_interested'
                            onChange={(e) => { handleFieldValue(e) }}
                            placeholder="Mention choice of specialty (if any)"
                        />
                    </Form.Group>
                }


                <Form.Group className="mb-3">
                    <label className="d-block mb-2">
                        Are you open to volunteering in
                        Healthcare Fairs?
                    </label>
                    <Form.Check
                        inline
                        label="Yes"
                        type="radio"
                        value='true'
                        checked={Fieldval && (Fieldval.volunteering_healthcare_fairs === 'true' || Fieldval.volunteering_healthcare_fairs === true) && true}
                        required={!Fieldval.volunteering_healthcare_fairs && true}
                        onChange={(e) => { handleFieldValue(e) }}
                        name="volunteering_healthcare_fairs"
                        id="a3"
                    />
                    <Form.Check
                        inline
                        label="No"
                        type="radio"
                        value='false'
                        checked={Fieldval && (Fieldval.volunteering_healthcare_fairs === 'false' || Fieldval.volunteering_healthcare_fairs === false) && true}
                        onChange={(e) => { handleFieldValue(e) }}
                        name="volunteering_healthcare_fairs"
                        id="a4"
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <label className="d-block mb-2">
                        Interested in being considered in a
                        new graduate program?
                    </label>
                    <Form.Check
                        inline
                        label="Yes"
                        type="radio"
                        value='true'
                        checked={Fieldval && (Fieldval.graduate_program === 'true' || Fieldval.graduate_program === true) && true}
                        required={!Fieldval.graduate_program && true}
                        onChange={(e) => { handleFieldValue(e) }}
                        name="graduate_program"
                        id="a5"
                    />
                    <Form.Check
                        inline
                        label="No"
                        type="radio"
                        value='false'
                        checked={Fieldval && (Fieldval.graduate_program === 'false' || Fieldval.graduate_program === false) && true}
                        onChange={(e) => { handleFieldValue(e) }}
                        name="graduate_program"
                        id="a6"
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <label className="d-block mb-2">
                        Are you currently working in
                        healthcare?
                    </label>
                    <Form.Check
                        inline
                        label="Yes"
                        type="radio"
                        checked={Fieldval && (Fieldval.working_healthcare === 'true' || Fieldval.working_healthcare === true) && true}
                        required={!Fieldval.working_healthcare && true}
                        name="working_healthcare"
                        value='true'
                        onChange={(e) => { handleFieldValue(e) }}
                        id="a7"
                    />
                    <Form.Check
                        inline
                        label="No"
                        type="radio"
                        name="working_healthcare"
                        value='false'
                        checked={Fieldval && (Fieldval.working_healthcare === 'false' || Fieldval.working_healthcare === false) && true}
                        onChange={(e) => { handleFieldValue(e) }}
                        id="a8"
                    />
                </Form.Group>
                {(Fieldval.working_healthcare === 'true' || Fieldval.working_healthcare === true) &&
                    <>

                        <Form.Group
                            controlId="formFile"
                            className="mb-3"
                        >
                            <Form.Label>
                                Name of organization
                            </Form.Label>
                            <Form.Control
                                type="text"
                                defaultValue={Fieldval && Fieldval.organization_name && Fieldval.organization_name}
                                required={Fieldval.working_healthcare === "true" && true}
                                name='organization_name'
                                onChange={(e) => { handleFieldValue(e) }}
                                placeholder="Enter Name of organization"
                            />
                        </Form.Group>

                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                        >
                            <Form.Label>
                                Description of work
                            </Form.Label>
                            <Form.Control name='description_of_work'
                                defaultValue={Fieldval && Fieldval.description_of_work && Fieldval.description_of_work}
                                required={Fieldval.working_healthcare === "true" && true}
                                onChange={(e) => { handleFieldValue(e) }}
                                as="textarea" rows={3} />
                        </Form.Group>
                    </>


                }

                <Form.Group
                    className="mb-3"
                    controlId="formBasicCheckbox"
                >
                    <Form.Check type="checkbox">
                        <Form.Check.Input type="checkbox" required />
                        <Form.Check.Label>
                            <p className="sign_agree">
                                I certify that everything is
                                correct.
                            </p>
                        </Form.Check.Label>
                    </Form.Check>
                </Form.Group>

                {/* <SignaturePad className="signup_sgntr" /> */}

                <Button
                    className="btn_theme w-100 mt-4"
                    type="submit"
                    variant=""
                >
                    {props.Button}
                </Button>
            </Form>

        </div >
    )
}

export default StudenInfoThird